import { CompanyDefaultUnitOfMeasurement, CompanyPreferredMeasurementSystemEnum } from "@/graphql/codegen/graphql"

export const preferredMeasurementSystemMapping = {
  [CompanyPreferredMeasurementSystemEnum.UsStandard]: "US Standard",
  [CompanyPreferredMeasurementSystemEnum.Metric]: "Metric",
}

export const defaultUomMapping = {
  [CompanyDefaultUnitOfMeasurement.MetricWeightKilogram]: "Kilogram",
  [CompanyDefaultUnitOfMeasurement.MetricWeightTon]: "Metric Ton",
  [CompanyDefaultUnitOfMeasurement.UsstdWeightPound]: "Pound",
  [CompanyDefaultUnitOfMeasurement.UsstdWeightShortTon]: "Short Ton",
}
